<template>
  <div />
</template>

<script>
export default {
  name: "YearControls",
  mounted() {
    window.addEventListener("keyup", this.keyup);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.keyup);
  },
  methods: {
    keyup(e) {
      if (
        this.$store.state.ui.mode === "narrative" ||
        this.$store.state.ui.mode === "no-map" ||
        this.$store.state.ui.mode === "no-years" ||
        !(e.code === "ArrowUp" || e.code === "ArrowDown")
      )
        return;
      let newYearIs = this.yearIndices;

      if (e.code === "ArrowUp") {
        newYearIs = newYearIs.map(i =>
          i < this.$store.state.years.length - 1 ? i + 1 : i
        );
      } else if (e.code === "ArrowDown") {
        newYearIs = newYearIs.map(i => (i > 0 ? i - 1 : i));
      }

      let newYearString = newYearIs
        .map(i => this.$store.state.years[i])
        .join(",");

      if (newYearString !== this.$route.params.year) {
        this.$router.push({
          params: { year: newYearString },
          query: this.$route.query
        });
      }
    }
  },
  computed: {
    years() {
      if (!this.$route.params.year) return ["1966"];
      let years = this.$route.params.year.split(",");
      return years;
    },
    yearIndices() {
      return this.years.map(y => this.$store.state.years.indexOf(y));
    }
  }
};
</script>
